export default __webpack_public_path__ + "static/media/4.5872abb8.png";